document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('CollectionFiltersForm');
  if (!form) return;

  const sectionId = form.closest('.shopify-section').id.replace('shopify-section-', '');
  const productGridContainer = document.querySelector('.collection-main');

  const sortSelect = document.getElementById('SortBy');

  const updateFilters = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    
    if (productGridContainer) {
      productGridContainer.style.opacity = '0.5';
      productGridContainer.style.pointerEvents = 'none';
      productGridContainer.style.transition = 'opacity 0.2s ease';
    }

    const formData = new FormData(form);
    if (sortSelect) {
      formData.set('sort_by', sortSelect.value);
    }
    
    const searchParams = new URLSearchParams(formData).toString();
    const url = window.location.pathname + '?' + searchParams;

    window.history.pushState({ path: url }, '', url);

    fetch(url + '&section_id=' + sectionId)
      .then(response => response.text())
      .then(html => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newMain = parsed.querySelector('.collection-main');
        if (newMain && productGridContainer) {
          productGridContainer.innerHTML = newMain.innerHTML;
        }
      })
      .catch(err => console.error('Filter fetch error:', err))
      .finally(() => {
        if (productGridContainer) {
          productGridContainer.style.opacity = '1';
          productGridContainer.style.pointerEvents = 'auto';
        }
      });
  };

  form.addEventListener('change', updateFilters);
  if (sortSelect) {
    sortSelect.addEventListener('change', updateFilters);
  }
});